import { registerFunctionalComponent } from 'js/lib/components/component'

registerFunctionalComponent('.js-c-stepped-form', 'SteppedFormComponent', SteppedFormComponent)

function SteppedFormComponent(component) {
  const wrapper = component.element
  let lastKnownHeight = wrapper.offsetHeight
  let isAnimating = false

  const observer = new ResizeObserver(([entry]) => {
    const newHeight = entry.contentRect.height

    if (isAnimating || lastKnownHeight === 0 || Math.abs(lastKnownHeight - newHeight) < 2) {
      lastKnownHeight = newHeight || lastKnownHeight
      return
    }

    observer.disconnect()
    isAnimating = true

    // Scroll the top of the form into view when the step changes
    if (wrapper.getBoundingClientRect().top < 0) {
      const top = wrapper.getBoundingClientRect().top + window.scrollY - 100
      window.scrollTo({ top, behavior: 'smooth' })
    }

    wrapper.style.overflow = 'hidden'
    wrapper.style.height = lastKnownHeight + 'px'
    wrapper.style.transition = 'height 300ms ease'

    requestAnimationFrame(() => {
      wrapper.style.height = newHeight + 'px'

      const cleanup = () => {
        clearTimeout(safetyTimeout)
        wrapper.removeEventListener('transitionend', onEnd)
        wrapper.style.height = ''
        wrapper.style.overflow = ''
        wrapper.style.transition = ''
        lastKnownHeight = wrapper.offsetHeight
        isAnimating = false
        observer.observe(wrapper)
      }

      const safetyTimeout = setTimeout(cleanup, 350)

      const onEnd = (e) => {
        if (e.target !== wrapper) return
        cleanup()
      }

      wrapper.addEventListener('transitionend', onEnd)
    })
  })

  observer.observe(wrapper)

  component.useHandler(() => () => observer.disconnect())
}
